import { Component, Input, OnChanges } from "@angular/core";
import { Severity } from "@app2/shared/shared-constants";
import { Dictionary } from "@app2/util/common-types";
import { TriggerSeverity } from "@app2/clients/types/alert-typedefs";

type SeverityInfo = {class: string, descriptionKey: string, icon: string};

@Component({
    selector: "severity-icon",
    template: `
        <ng-container *ngIf="severityInfo">
            <strong [ngClass]="severityInfo.class" [title]="severityInfo.descriptionKey | localize">
                {{ severityInfo.icon }}
            </strong>
            <ng-container *ngIf="description && severityInfo.descriptionKey">
                {{ severityInfo.descriptionKey | localize }}
            </ng-container>
        </ng-container>
    `,
})
export class SeverityIconComponent implements OnChanges {
    @Input() severity: Severity | TriggerSeverity;
    @Input() description: boolean;

    severities: Dictionary<SeverityInfo> = {
        "high": { class: "severity-high", descriptionKey: "SEVERITY_HIGH", icon: "•••" },
        "medium": { class: "severity-medium", descriptionKey: "SEVERITY_MEDIUM", icon: "••" },
        "low": { class: "severity-low", descriptionKey: "SEVERITY_LOW", icon: "•" },
        "informational": { class: "hidden", descriptionKey: "INFORMATIONAL", icon: "" },
        "test": { class: "hidden", descriptionKey: "TEST", icon: "" },
        "none": { class: "hidden", descriptionKey: "NONE", icon: "" },
    };
    severityInfo: SeverityInfo;

    ngOnChanges() {
        if (this.severity) {
            this.severityInfo = this.severities[this.severity.toLowerCase()];
        }
    }
}
